<template>
  <!-- 资源 -->
  <div class="tab-page">
    <div class="head">
      <div class="pointer">
        <el-button type="primary" round :plain="currIndex !== 1" @click="handleSwitch(1)">文化活动</el-button>
        <el-button type="primary" round :plain="currIndex !== 2" @click="handleSwitch(2)">活动资讯</el-button>
        <el-button type="primary" round :plain="currIndex !== 3" @click="handleSwitch(3)">活动图片</el-button>
      </div>
      <div class="searchcontain">
        <el-input v-model="queryParams.keyword" placeholder="搜索" suffix-icon="el-icon-search"
          style="font-size: 14px; width: 330px;" @change="handleSearch" class="searchInput"></el-input>
      </div>
    </div>
    <div class="content-box" v-loading="loading">
      <template v-if="listData.length > 0">
        <component :is="currComp" :list="listData" @updateComponent="getList"></component>
        <div class="elpagination">
          <div class="elpagination-title">共{{ total }}条</div>
          <el-pagination background layout="prev, pager, next, jumper" prev-text="上一页" next-text="下一页" :total="total"
            :current-page="queryParams.page" :page-size="9" @size-change="changeSize"
            @current-change="changePage"></el-pagination>
        </div>
      </template>
      <template v-else>
        <el-empty :image-size="110" class="el-empty--cont"></el-empty>
      </template>
    </div>
  </div>
</template>

<script>
import { getActivityList, getActivePictureList, getNewsList } from "@/api/activity"
import Activity from "./components/activity.vue" // 文化活动
import News from "./components/news.vue" // 活动资讯
import Album from "./components/album.vue" // 活动图片

export default {
  name: "MyResource",
  components: {
    Activity,
    News,
    Album,
  },
  filters: {},
  data() {
    return {
      currComp: "Activity",
      currIndex: 1,
      queryParams: {
        keyword: "",
        is_collect: 1,
        per_page: 9,
        page: 1,
      },
      listData: [],
      total: 0,
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 我加入的项目列表
    getList(inx, condi) {
      this.loading = true
      let $Api = null
      switch (this.currIndex) {
        case 1:
          $Api = getActivityList
          break
        case 2:
          $Api = getNewsList
          break
        default:
          $Api = getActivePictureList
          break
      }
      $Api(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.listData = res.data?.data ?? []
          this.total = res.data?.total ?? 0
          if (condi) {
            switch (inx) {
              case 1:
                this.currComp = "Activity"
                break
              case 2:
                this.currComp = "News"
                break
              default:
                this.currComp = "Album"
                break
            }
          }
        }
      }).catch(() => { })
    },
    // 分页-当页条数
    changeSize(data) {
      this.queryParams.per_page = data
      this.getList()
    },
    // 分页-当前页数
    changePage(data) {
      this.queryParams.page = data
      this.getList()
    },
    // 查询
    handleSearch() {
      this.queryParams.page = 1 // 搜索默认查询第一页
      this.getList()
    },
    // 切换内容
    handleSwitch(type) {
      this.currIndex = type
      this.listData = []
      this.total = 0
      this.getList(type, true)
    },
  },
};
</script>
<style scoped lang="scss">
.tab-page {
  padding: 30px 30px 40px;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchcontain {
      position: relative;

      .elinput {
        width: 260px;
        height: 35px;
        border-radius: 25px;
        padding-left: 20px;
        border: 1px solid #005cbb;

        &:focus {
          outline: none;
        }
      }

      .searchbt {
        position: absolute;
        top: 0px;
        right: 0px;
        margin-left: 17px;
        width: 85px;
        height: 38px;
        background: #005cbb;
        border-radius: 25px;
        font-size: 15px;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 38px;
        cursor: pointer;
        user-select: none;

        &:active {
          background: #005cbba9;
        }

        .search_img {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url('~@/assets/home/search.png');
          background-size: cover;
          vertical-align: middle;
        }
      }
    }
  }

  .content-box {
    // padding: 20px;
    background: #ffffff;
    box-sizing: border-box;

    .el-empty--cont {
      padding: 0px;
      min-height: 400px;
    }
  }

  .elpagination {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .elpagination-title {
      margin-right: 4px;
    }
  }

  ::v-deep .searchInput {
    .el-input__inner {
      border-radius: 40px;
    }

    .el-input__suffix {
      font-size: 18px;
    }
  }
}

@media screen and (max-width: 640px) {
  .tab-page {
    .head {
      flex-direction: column;
      align-items: flex-start;

      .pointer {
        margin-bottom: 10px;

        .el-button {
          padding: 7px 12px;
          font-size: 12px;
        }
      }

      .searchcontain {
        width: 100%;

        .searchInput {
          width: 100% !important;
        }
      }
    }

    .content-box {
      .elpagination {
        // flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        .elpagination-title {
          margin-bottom: 10px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}
</style>